import React from 'react';
import { ComponentPage, DemoCard } from '../../shared';
import { ColorSwatch } from './tokenHelpers';

const GRAYS = ['0', '025', '05', '075', '1', '2', '3', '4', '5', '6', '7', '8', '9', '925', '950', '975', '10'];

export const meta = {
  title: 'Colors',
  group: 'Foundations',
  description:
    'A 17-step neutral ramp, six brand colours and nine UI state colours. Brand and neutral values change with the data-brand attribute; UI states are identical across brands so success always reads as success.',
  usage: [
    {
      title: 'Using a colour',
      code: `/* Always the variable — never a hex, never a Tailwind colour class */
.my-block {
  color: var(--color-gray-10);
  background: var(--color-gray-025);
  border: var(--border-input-width) solid var(--color-gray-1);
}

/* Error and success states */
.my-block--error {
  color: var(--color-ui-error);
  background: var(--color-ui-error-background);
}`,
    },
    {
      title: 'Switching brand',
      code: `// The attribute on <html> is the only switch. Every token below
// re-resolves; no component needs to know which brand is active.
document.documentElement.setAttribute('data-brand', 'ABC');

// theme.css
// :root[data-brand="CLS"] { --color-brand-primary: #28e280; }
// :root[data-brand="ABC"] { --color-brand-primary: #213469; }`,
    },
  ],
};

export default function ColorsPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Brand" hint="changes with data-brand">
        <div className="ds-swatch-grid">
          <ColorSwatch name="Primary" variable="--color-brand-primary" />
          <ColorSwatch name="Primary Hover" variable="--color-brand-primary-hover" />
          <ColorSwatch name="Primary Alternative" variable="--color-brand-primary-alternative" />
          <ColorSwatch name="Secondary" variable="--color-brand-secondary" />
          <ColorSwatch name="Secondary Hover" variable="--color-brand-secondary-hover" />
          <ColorSwatch name="Accent" variable="--color-brand-accent" />
        </div>
      </DemoCard>

      <DemoCard title="Gray scale" hint="17 steps, 0 → 10">
        <div className="ds-swatch-list">
          {GRAYS.map((step) => (
            <ColorSwatch
              key={step}
              name={`Gray ${step}`}
              variable={`--color-gray-${step}`}
              layout="row"
            />
          ))}
        </div>
      </DemoCard>

      <DemoCard title="UI states" hint="identical in both brands">
        <div className="ds-swatch-grid ds-swatch-grid--triads">
          <ColorSwatch name="Success" variable="--color-ui-success" />
          <ColorSwatch name="Success Hover" variable="--color-ui-success-hover" />
          <ColorSwatch name="Success BG" variable="--color-ui-success-background" />
          <ColorSwatch name="Warning" variable="--color-ui-warning" />
          <ColorSwatch name="Warning Hover" variable="--color-ui-warning-hover" />
          <ColorSwatch name="Warning BG" variable="--color-ui-warning-background" />
          <ColorSwatch name="Error" variable="--color-ui-error" />
          <ColorSwatch name="Error Hover" variable="--color-ui-error-hover" />
          <ColorSwatch name="Error BG" variable="--color-ui-error-background" />
        </div>
      </DemoCard>

      <DemoCard title="Configurator" hint="product configurator selectors">
        <div className="ds-swatch-grid">
          <ColorSwatch name="Selector Background" variable="--color-configurator-selector-background" />
          <ColorSwatch name="Selector Border" variable="--color-configurator-selector-border" />
        </div>
      </DemoCard>
    </ComponentPage>
  );
}
